// src/components/admin/AddVariant.js
import React, { useState, useEffect } from "react";
import {
  Container, TextField, Button, Typography, Box, FormControl,
  InputLabel, Select, MenuItem
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { productsAPI, variantsAPI } from "../../services/api";
import BackToDashboard from "../common/BackToAdminDashboard";

const AddVariant = () => {
  const { t } = useTranslation();
  const [products, setProducts] = useState([]);
  const [form, setForm] = useState({
    product_id: "",
    brand_name_en: "",
    brand_name_el: "",
    price: "",
    unit_en: "",
    unit_el: ""
  });
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    productsAPI.list().then(res => setProducts(res.data || []));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await variantsAPI.add({
        ...form,
        price: parseFloat(form.price)
      });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.response?.data?.error || t("failed_to_add_variant"));
    }
  };

  return (
    <Container sx={{ mt: 4 }}>
      <BackToDashboard dashboardPath="/admin/dashboard" />
      <Typography variant="h4" gutterBottom>
        {t("add_variant")}
      </Typography>
      {error && <Typography color="error">{error}</Typography>}
      <form onSubmit={handleSubmit}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <FormControl fullWidth required>
            <InputLabel>{t("product")}</InputLabel>
            <Select
              name="product_id"
              value={form.product_id}
              onChange={handleChange}
              label={t("product")}
            >
              {products.map(p => (
                <MenuItem key={p.id} value={p.id}>
                  {p.name_en}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label={t("brand_name_en")}
            name="brand_name_en"
            fullWidth
            required
            value={form.brand_name_en}
            onChange={handleChange}
          />
          <TextField
            label={t("brand_name_el")}
            name="brand_name_el"
            fullWidth
            required
            value={form.brand_name_el}
            onChange={handleChange}
          />
          <TextField
            label={t("price")}
            name="price"
            type="number"
            fullWidth
            required
            value={form.price}
            onChange={handleChange}
          />
          <TextField
            label={t("unit_en")}
            name="unit_en"
            fullWidth
            value={form.unit_en}
            onChange={handleChange}
          />
          <TextField
            label={t("unit_el")}
            name="unit_el"
            fullWidth
            value={form.unit_el}
            onChange={handleChange}
          />
          <Button type="submit" variant="contained" color="primary">
            {t("add_variant")}
          </Button>
        </Box>
      </form>
    </Container>
  );
};

export default AddVariant;